import { render } from "./WeightLossContent.vue?vue&type=template&id=a168a67e&scoped=true"
import script from "./WeightLossContent.vue?vue&type=script&lang=js"
export * from "./WeightLossContent.vue?vue&type=script&lang=js"

import "./WeightLossContent.vue?vue&type=style&index=0&id=a168a67e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a168a67e"]])

export default __exports__